import { useQuery } from 'react-query'
import { IBalance} from '../common/types'
import { getBalances } from '../service/balances'

export const useBalances = () => {

  // Query
  return useQuery<IBalance[] | undefined>('balances', getBalances)
}